import React, { useState } from "react";
import cellEditFactory from "react-bootstrap-table2-editor";
import BootstrapTable from "react-bootstrap-table-next";
import { Type } from "react-bootstrap-table2-editor";

import { dateFormat } from "utils/format";
import { Cut } from "components/Cut";
import { updateBrand } from "services/api";

import "./brandsTable.scss";
import { BrandModal } from "../BrandModal";

export const BrandsTable = ({
  brands,
  getAndSetBrands,
  setLoading,
  setSelected
}) => {

  const [id, setId] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const editHandler = (oldData, newData, row) => {
    if (String(oldData) === String(newData)) return;
    setLoading(true);
    updateBrand({
      id: row.id,
      active: row.active === "Да" ? true : false
    })
      .then(() => getAndSetBrands())
      .finally(() => { });
  };

  const selectRow = {
    mode: "checkbox",
    bgColor: "#bfbfbf",
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelected((prev) => {
        if (!isSelect) {
          prev.splice(
            prev.findIndex((val) => val === row.id),
            1
          );
          return [...prev];
        }
        return [...prev, row.id];
      });
    },
    onSelectAll: (isSelect, rows, e) => {
      if (!isSelect) {
        setSelected([]);
      } else {
        setSelected(brands.map((val) => val.id));
      }
    },
  };

  const rowEvents = {
    onClick: (e, row) => {
      setId(row.id);
      setOpenModal(true);
    },
  }

  const tableColumns = [
    {
      dataField: "name",
      text: "Бренд",
      classes: () => "editable",
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      formatter: (cell, row) => <Cut>{cell}</Cut>,
      editable: false,
      events: {
        onClick: (e) => {
          e.stopPropagation();
        },
      },
    },
    {
      dataField: "active",
      text: "Активен",
      classes: (cell) =>
        cell === "Нет" ? "editable inactive" : "editable active",
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editor: {
        type: Type.CHECKBOX,
        value: "Да:Нет",
      },
      events: {
        onClick: (e) => {
          e.stopPropagation();
        },
      },
    },
    {
      dataField: "countNomenclature",
      text: "Номенклатура",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "countCross",
      text: "Кроссы",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "synonym",
      text: "Синонимы",
      formatter: (cell, row) => <Cut width>{cell}</Cut>,
      headerStyle: (colum, colIndex) => {
        return { width: "52%" };
      },
      editable: false,
    },
    {
      dataField: "createdBy",
      text: "Создал",
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      formatter: (cell, row) => <Cut width>{cell}</Cut>,
      editable: false,
    },
    {
      dataField: "createdAt",
      text: "Дата добавления",
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      formatter: (cell) => dateFormat(cell),
      editable: false,
    },
  ];

  return (
    <>
      <BootstrapTable
        keyField="id"
        data={brands}
        columns={tableColumns}
        bootstrap4
        bordered={false}
        hover={true}
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
          afterSaveCell: (oldData, newData, row) =>
            editHandler(oldData, newData, row),
        })}
        selectRow={selectRow}
        rowEvents={rowEvents}
        classes="pointer"
      />

      <BrandModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        id={id}
      />
    </>
  );
};